import BeinScammedCard from './BeingScammedCard.jsx';

export default BeinScammedCard;